import { setOrganizationFullAddress } from 'src/utils/escrow';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Card, CardHeader, CardContent, CardDescription, CardTitle, CardFooter } from '@/components/ui/card';
import { OrganizationRegistrationNumberTooltip } from '@/components/Organization';

import { useDepositorContext } from '../model';

import EditDepositorDialog from './EditDepositorDialog';

const DepositorOrganization = () => {
  const { depositor } = useDepositorContext();

  const address = {
    street: depositor?.street || '',
    streetNumber: depositor?.streetNumber || '',
    city: depositor?.city || '',
    postalCode: depositor?.postalCode || '',
    region: depositor?.region || '',
    country: depositor?.country || '',
  };

  const rows = [
    {
      id: 'organization-name',
      label: 'Organization Name',
      value: depositor?.companyName,
    },
    {
      id: 'website',
      label: 'Website',
      value: depositor?.companyWebsite || '-',
    },
    {
      id: 'registration-number',
      label: (
        <div className="flex items-center gap-1">
          Registration Number <OrganizationRegistrationNumberTooltip />
        </div>
      ),
      value: depositor?.companyRegistrationNumber || '-',
    },
    {
      id: 'address',
      label: 'Address',
      value: setOrganizationFullAddress(address),
    },
  ];

  return (
    <Card className="flex flex-col">
      <CardHeader className="shrink-0">
        <CardTitle>Depositor organization details</CardTitle>
        <CardDescription>
          What are your company&apos;s details?
          <br />
          This includes the registered name and address of the entity, which will be listed in the escrow agreement.
        </CardDescription>
      </CardHeader>
      <CardContent className="grow">
        <Table>
          <TableBody>
            {rows.map(({ id, label, value }) => (
              <TableRow key={id}>
                <TableCell className="w-[195px] font-medium text-muted-foreground">{label}</TableCell>
                <TableCell className="w-[80px]">:</TableCell>
                <TableCell>
                  <div className="min-w-[190px]">{value}</div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      {depositor?.policy.update && (
        <CardFooter className="pt-6 shrink-0">
          <div className="flex justify-end bg-muted w-full py-2 px-4">
            <EditDepositorDialog />
          </div>
        </CardFooter>
      )}
    </Card>
  );
};

export default DepositorOrganization;
